import { map, get, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { QuaternaryParagraphHeading } from 'components/Headings';
import TopNavigationTileOption from 'components/TopNavigationTileOption';
import { TYPES } from 'constants/topNavigation';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

import Level2Section2 from './Level2Section';

const TopNavigationSubNavigationDesktop = ({
  l1ActiveNode,
  trackNavigation,
  trackNavigationClick,
}) => {
  const handleTileClick = ({ url, label }) => {
    trackNavigation(url);
    trackNavigationClick({
      navigationType: TYPES.LEVEL_3,
      navigationLevel1: l1ActiveNode.label,
      navigationLevel2: I18n.localize('nav.collections'),
      navigationLevel3: label,
      navigationSource: window.location.href,
    });
  };
  return (
    <div className="TopNavigationSubNavigationDesktop">
      <ul className="TopNavigationSubNavigationDesktop__layout">
        {map(get(l1ActiveNode, 'subNavigations'), l2Option => (
          <li
            className="TopNavigationSubNavigationDesktop__column"
            key={`${l2Option.id}--desktop-container`}
          >
            <Level2Section2
              l1Label={l1ActiveNode.label}
              l2Option={l2Option}
              trackNavigation={trackNavigation}
              trackNavigationClick={trackNavigationClick}
              key={`${l2Option.id}--desktop`}
              layoutRowPosition={l2Option.layoutRowPosition}
            />
          </li>
        ))}
        {!isEmpty(get(l1ActiveNode, 'featuredCollections')) && (
          <li className="TopNavigationSubNavigationDesktop__column">
            <QuaternaryParagraphHeading className="TopNavigationSubNavigationDesktop__collection-heading">
              {I18n.localize('nav.collections')}
            </QuaternaryParagraphHeading>
            <ul className="TopNavigationSubNavigationDesktop__featured-collection-list">
              {map(get(l1ActiveNode, 'featuredCollections'), featuredCollection => (
                <li className="TopNavigationSubNavigationDesktop__featured-collection-item">
                  <TopNavigationTileOption
                    title={get(featuredCollection, 'label')}
                    image={get(featuredCollection, ['desktopImage', 'src'])}
                    key={`${get(featuredCollection, 'label')}--desktop`}
                    href={get(featuredCollection, 'linkUrl')}
                    onClick={() =>
                      handleTileClick({
                        url: get(featuredCollection, 'linkUrl'),
                        label: get(featuredCollection, 'label'),
                      })
                    }
                  />
                </li>
              ))}
            </ul>
          </li>
        )}
      </ul>
      <style jsx>
        {`
          .TopNavigationSubNavigationDesktop {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            padding-top: ${Theme.get('spacing') * 10}px;
            padding-bottom: ${Theme.get('spacing') * 4}px;
          }

          .TopNavigationSubNavigationDesktop__layout {
            max-width: ${Theme.get('container-width-max-px')};
            width: 100%;
            margin: 0 auto;
            list-style: none;
            padding: 0 ${Theme.get('spacing') * 21}px;
            display: flex;
            justify-content: center;
          }

          .TopNavigationSubNavigationDesktop__column {
            min-width: ${Theme.get('container-width-max') / 7}px;
            width: 20%;
            margin-right: ${Theme.get('spacing') * 4}px;
          }

          .TopNavigationSubNavigationDesktop__column:last-child {
            margin-right: 0;
            width: 40%;
          }

          .TopNavigationSubNavigationDesktop__featured-collections {
            display: flex;
            flex-direction: column;
          }

          .TopNavigationSubNavigationDesktop__featured-collection-item {
            margin-bottom: ${Theme.get('spacing') * 4}px;
          }
        `}
      </style>
      <style jsx global>
        {`
          .TopNavigationSubNavigationDesktop__collection-heading.typography--quaternary-heading {
            margin-bottom: ${Theme.get('spacing') * 5}px;
          }
        `}
      </style>
    </div>
  );
};

TopNavigationSubNavigationDesktop.propTypes = {
  l1ActiveNode: PropTypes.shape({
    name: PropTypes.string,
    label: PropTypes.string,
    subNavigations: PropTypes.arrayOf(PropTypes.shape({})),
    id: PropTypes.string.isRequired,
  }),
  trackNavigation: PropTypes.func.isRequired,
  trackNavigationClick: PropTypes.func.isRequired,
};

TopNavigationSubNavigationDesktop.defaultProps = {
  l1ActiveNode: null,
};

export default TopNavigationSubNavigationDesktop;
